// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5066":"b4aba6bd","5478":"f4fab3f6"}[chunkId] + ".chunk.js";
};